/*
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */

import { styled } from '@mui/material';
import { memo, useMemo, useRef } from 'react';

import { FlightTurnaroundDto } from '../../../../../backend';
import { getTurnaroundActualOccupation } from '../../RmsContent.utils';
import { useRmsGanttValue } from '../../RmsContext';
import { ganttPxPerMs } from '../gantt.constants';
import { TurnaroundBox } from '../GanttRow/TurnaroundBox/TurnaroundBox/TurnaroundBox';

export const GanttSelection = memo(function GanttSelection({
    selectedTurnaround,
}: {
    selectedTurnaround: FlightTurnaroundDto;
}) {
    const dayBounds = useRmsGanttValue('dayBounds');
    const mousePositionY = useRmsGanttValue('mousePositionY');
    const isDragging = useRmsGanttValue('isDragging');
    const isFocused = useRmsGanttValue('isFocused');

    const selectionOccupation = getTurnaroundActualOccupation(selectedTurnaround);

    const turnaroundSlotRef = useRef(null);

    const marginValue = useMemo(() => {
        const top = turnaroundSlotRef?.current?.getBoundingClientRect().top || 0;
        return mousePositionY - top - 40;
    }, [mousePositionY]);

    return (
        <>
            {isFocused && selectionOccupation && (
                <StyledGanttSelection
                    id={'turnaroundSlot'}
                    ref={turnaroundSlotRef}
                    from={selectionOccupation.occupationStart?.time}
                    to={Math.min(selectionOccupation.occupationEnd?.time, dayBounds?.to)}
                    left={(selectionOccupation.occupationStart?.time - dayBounds.from) * ganttPxPerMs * 2}
                >
                    {isDragging && <TurnaroundBox turnaround={selectedTurnaround} marginValue={marginValue} />}
                </StyledGanttSelection>
            )}
        </>
    );
});

export const StyledGanttSelection = styled('div', {
    shouldForwardProp: () => true,
})<{ from: number; to: number; left: number }>`
    position: absolute;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    width: ${({ from, to }) => (to - from) * ganttPxPerMs * 2}px;
    height: 100%;
    background: #ffffff30;
    margin-left: ${({ left }) => left}px;
`;
